/**
 * @summary     app.jurisdiction.js
 * @description App JS jurisidction Controller
 * @version     1.0
 	> 1.0 Initial version
		- 02/15/2023 SG
 * @author      Silas Garrison
 ** EXAMPLES:
 ** NOTE:
 ** TODO:
*/

app.addFeature(
	"jurisdiction",
	function(){
		"use strict";

		const self = this;
		let jurisdictionObj = null;
		let jurisdictionName = null;

		/*
			Name: init
			Use: API.init()
			Args: none
			Description: initialization
		*/
		self.init = async () => {
			jurisdictionName = $('#target_jurisdictionName').val()??document.location.pathname.split('/')[1]??null;

      const jurRes = await new Promise((resolve, reject) => {
        if(!jurisdictionName) {
          return resolve({error:true});
        }
        app.exo.readOne(
          'jurisdictions',
          {
            path: jurisdictionName
          }
        ).finished(resolve);
      });

      jurisdictionObj = (!jurRes.error) ? jurRes.data : null;
      console.log('jurisdiction initialized!');
		};

		self.get = (objectOrName) => {
			/*
				NOTE:
					The jurisdictionName occurs during app initialization and this could get called prior
			*/
			if((objectOrName ?? 'object' === 'name') && !jurisdictionName){
				jurisdictionName = $('#target_jurisdictionName').val()??document.location.pathname.split('/')[1]??null
			}

			return objectOrName ?? 'object' === 'name' ? jurisdictionName : JSON.clone(jurisdictionObj);
		};

		self.getAsync = () => {
			return new Promise(async function(resolve, reject) {
				if(jurisdictionObj){
					resolve(JSON.clone(jurisdictionObj));
				}
				else {
					app.exo.readOne(
						'jurisdictions',
						{
							path: self.get('name')
						}
					).finished(
						(res) => {
							resolve(res.data);
						}
					);
				}
			});
		}

		return self;
	}
);
